module.exports = __webpack_public_path__ + "static/img/lab-m-effect.1bb2a119.png";